// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"c36433cd","233":"22ac0926","234":"ba0952a4","325":"d0699305","486":"427f2a3e","550":"3c4f8973","796":"22a0a549","891":"3c817994","983":"20772010"}[chunkId] + ".chunk.js";
};